import { withMemberContext } from '@/config/site'
import request from '@/utils/request'

export const ACTIVITY_PAGE_VIEW = 1
export const ACTIVITY_MATERIAL_READ = 2

export const reportLearningActivity = async (payload = {}) => {
  const response = await request('/page/course/learning-activity/report', {
    data: withMemberContext({
      device: 'web',
      ...payload
    })
  })

  return response.data || {}
}
